// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Chip,
//   IconButton,
//   Paper,
//   Grid,
//   Card,
//   CardContent,
//   Alert,
//   CircularProgress,
//   AppBar,
//   Toolbar,
//   Fab,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TableSortLabel,
// } from "@mui/material";
// import {
//   Add as AddIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   Visibility as ViewIcon,
//   Close as CloseIcon,
//   Pets as PetsIcon,
//   FilterList as FilterIcon,
//   Search as SearchIcon,
//   Pause as InactiveIcon,
//   PlayArrow as ReactivateIcon,
// } from "@mui/icons-material";
// import { TableVirtuoso } from "react-virtuoso";
// import { useNavigate } from "react-router-dom";
// import swal from "sweetalert";

// // Virtualized Table Components
// const VirtuosoTableComponents = {
//   Scroller: React.forwardRef((props, ref) => (
//     <TableContainer component={Paper} {...props} ref={ref} />
//   )),
//   Table: (props) => (
//     <Table
//       {...props}
//       sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
//     />
//   ),
//   TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
//   TableRow: (props) => <TableRow {...props} />,
//   TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
// };

// const InactiveAnimalsPage = () => {
//   const navigate = useNavigate();
//   const [animals, setAnimals] = useState([]);
//   const [filteredAnimals, setFilteredAnimals] = useState([]);
//   const [loading, setLoading] = useState(false);
  
//   // Filters and Search
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
//   const [filters, setFilters] = useState({
//     species: "",
//     breed: "",
//     sex: "",
//     animal_type: ""
//   });

//   const [showFilters, setShowFilters] = useState(false);

//   // Options and Form Data
//   const [options, setOptions] = useState({
//     species: [],
//     breeds: {},
//     sexes: [],
//     animal_classes: {},
//     lifecycle_states: [],
//     reproductive_statuses: [],
//     pregnancy_statuses: [],
//     milking_statuses: [],
//     semen_statuses: [],
//     health_statuses: []
//   });

//   const API_URL = "https://dairy.server.statify.co.ke/api/animals";

//   // Table Columns for Virtualized Table
//   const columns = [
//     { width: 120, label: 'Tag #', dataKey: 'tag_number' },
//     { width: 120, label: 'Name', dataKey: 'name' },
//     { width: 100, label: 'Species', dataKey: 'species' },
//     { width: 120, label: 'Breed', dataKey: 'breed' },
//     { width: 100, label: 'Type', dataKey: 'animal_type' },
//     { width: 80, label: 'Age', dataKey: 'age_string' },
//     { width: 80, label: 'Gender', dataKey: 'sex' },
//     { width: 120, label: 'Exit Reason', dataKey: 'exit_reason' },
//     { width: 100, label: 'Exit Date', dataKey: 'exit_date' },
//     { width: 180, label: 'Actions', dataKey: 'actions' },
//   ];

//   // Fetch Options
//   const fetchOptions = async () => {
//     try {
//       const res = await fetch(`${API_URL}/options`);
//       const data = await res.json();
//       if (res.ok) {
//         setOptions(data);
//       }
//     } catch (err) {
//       console.error('Error fetching options:', err);
//     }
//   };

//   // Fetch Inactive Animals
//   const fetchAnimals = async () => {
//     setLoading(true);
//     try {
//       const queryParams = new URLSearchParams();
//       Object.entries(filters).forEach(([key, value]) => {
//         if (value) queryParams.append(key, value);
//       });
//       queryParams.append('lifecycle_state', 'Inactive');

//       const url = `${API_URL}?${queryParams.toString()}`;
//       const res = await fetch(url);
//       const data = await res.json();
      
//       if (data.animals && Array.isArray(data.animals)) {
//         setAnimals(data.animals);
//       } else if (Array.isArray(data)) {
//         setAnimals(data);
//       } else {
//         setAnimals([]);
//       }
//     } catch (err) {
//       console.error('Error fetching inactive animals:', err);
//       swal("Error", "Failed to fetch inactive animals", "error");
//       setAnimals([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchOptions();
//     fetchAnimals();
//   }, [filters]);

//   // Filter animals based on search
//   useEffect(() => {
//     if (!Array.isArray(animals)) {
//       setFilteredAnimals([]);
//       return;
//     }
    
//     let results = animals;

//     // Apply search term
//     if (searchTerm) {
//       results = results.filter(animal =>
//         (animal.tag_number?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (animal.name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (animal.breed?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (animal.herd_id?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
//         (animal.exit_reason?.toLowerCase() || '').includes(searchTerm.toLowerCase())
//       );
//     }

//     // Apply sorting
//     if (sortConfig.key) {
//       results.sort((a, b) => {
//         const aVal = a[sortConfig.key];
//         const bVal = b[sortConfig.key];
        
//         if (aVal === null || aVal === undefined) return 1;
//         if (bVal === null || bVal === undefined) return -1;
        
//         if (typeof aVal === 'string' && typeof bVal === 'string') {
//           return sortConfig.direction === 'asc' 
//             ? aVal.localeCompare(bVal)
//             : bVal.localeCompare(aVal);
//         }
        
//         if (aVal < bVal) {
//           return sortConfig.direction === 'asc' ? -1 : 1;
//         }
//         if (aVal > bVal) {
//           return sortConfig.direction === 'asc' ? 1 : -1;
//         }
//         return 0;
//       });
//     }

//     setFilteredAnimals(results);
//   }, [animals, searchTerm, sortConfig]);

//   // Sort Handler
//   const handleSort = (key) => {
//     let direction = 'asc';
//     if (sortConfig.key === key && sortConfig.direction === 'asc') {
//       direction = 'desc';
//     }
//     setSortConfig({ key, direction });
//   };

//   // Filter Handlers
//   const handleFilterChange = (key, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [key]: value
//     }));
//   };

//   const resetFilters = () => {
//     setFilters({
//       species: "",
//       breed: "",
//       sex: "",
//       animal_type: ""
//     });
//     setSearchTerm("");
//     setSortConfig({ key: null, direction: 'asc' });
//   };

//   const handleReactivateAnimal = async (animalId) => {
//     const confirm = await swal({
//       title: "Reactivate Animal?",
//       text: "This will change the animal status back to Active",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     });

//     if (confirm) {
//       try {
//         const res = await fetch(`${API_URL}/${animalId}/status`, {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ 
//             lifecycle_state: "Active",
//             changed_by: "user" 
//           }),
//         });

//         const data = await res.json();
//         if (res.ok) {
//           swal("Success", "Animal reactivated successfully!", "success");
//           fetchAnimals();
//         } else {
//           swal("Error", data.error, "error");
//         }
//       } catch (err) {
//         swal("Error", "Something went wrong", "error");
//       }
//     }
//   };

//   // Delete Handler
//   const handleDelete = async (id) => {
//     const confirm = await swal({
//       title: "Are you sure?",
//       text: "This will permanently delete the animal!",
//       icon: "warning",
//       buttons: true,
//       dangerMode: true,
//     });

//     if (confirm) {
//       try {
//         const res = await fetch(`${API_URL}/${id}`, { method: "DELETE" });
//         const data = await res.json();
//         if (res.ok) {
//           swal("Deleted!", data.message, "success");
//           fetchAnimals();
//         } else {
//           swal("Error", data.error, "error");
//         }
//       } catch (err) {
//         swal("Error", "Something went wrong", "error");
//       }
//     }
//   };

//   // View Handler - Navigate to detail page
//   const handleView = (animalId) => {
//     navigate(`/animals/${animalId}`);
//   };

//   // Navigate to create draft
//   const handleCreateDraft = () => {
//     navigate('/animals/draft');
//   };

//   // Virtualized Table Content
//   const fixedHeaderContent = () => (
//     <TableRow>
//       {columns.map((column) => (
//         <TableCell
//           key={column.dataKey}
//           variant="head"
//           align="left"
//           style={{ width: column.width }}
//           sx={{ 
//             backgroundColor: 'error.main', 
//             color: 'white',
//             fontWeight: 'bold',
//             fontSize: '14px',
//             padding: '12px 8px'
//           }}
//         >
//           <TableSortLabel
//             active={sortConfig.key === column.dataKey}
//             direction={sortConfig.direction}
//             onClick={() => handleSort(column.dataKey)}
//             sx={{ color: 'white !important' }}
//           >
//             {column.label}
//           </TableSortLabel>
//         </TableCell>
//       ))}
//     </TableRow>
//   );

//   const rowContent = (index, animal) => (
//     <React.Fragment>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" fontWeight="bold" noWrap>
//           {animal.tag_number}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.name || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.species}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.breed}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Chip 
//           label={animal.purchase_price ? "PURCHASED" : "BORN"} 
//           size="small"
//           color={animal.purchase_price ? "primary" : "success"}
//           sx={{ fontSize: '0.7rem', height: '24px' }}
//         />
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.age_string || 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.sex}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Chip 
//           label={animal.exit_reason || 'Not specified'} 
//           size="small"
//           color="error"
//           sx={{ fontSize: '0.7rem', height: '24px' }}
//         />
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Typography variant="body2" noWrap>
//           {animal.exit_date ? new Date(animal.exit_date).toLocaleDateString() : 'N/A'}
//         </Typography>
//       </TableCell>
//       <TableCell sx={{ padding: '8px' }}>
//         <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
//           <IconButton 
//             size="small" 
//             color="primary"
//             onClick={() => handleView(animal.id)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//           >
//             <ViewIcon fontSize="small" />
//           </IconButton>
//           <Button 
//             size="small" 
//             variant="contained" 
//             color="primary"
//             startIcon={<ReactivateIcon />}
//             onClick={() => handleReactivateAnimal(animal.id)}
//             sx={{ 
//               minWidth: 'auto',
//               px: 1,
//               fontSize: '0.7rem',
//               height: '32px'
//             }}
//           >
//             Reactivate
//           </Button>
//           <IconButton 
//             size="small" 
//             color="error"
//             onClick={() => handleDelete(animal.id)}
//             sx={{ minWidth: '32px', width: '32px', height: '32px' }}
//           >
//             <DeleteIcon fontSize="small" />
//           </IconButton>
//         </Box>
//       </TableCell>
//     </React.Fragment>
//   );

//   return (
//     <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
//       {/* Header */}
//       <AppBar position="static" elevation={2} sx={{ backgroundColor: 'error.dark' }}>
//         <Toolbar>
//           <InactiveIcon sx={{ mr: 2 }} />
//           <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
//             Inactive Animals
//           </Typography>
//           <Chip 
//             label={`${animals.length} Inactive`} 
//             color="error" 
//             variant="filled"
//             sx={{ color: 'white', fontWeight: 'bold', mr: 2 }}
//           />
//           <Button 
//             variant="contained" 
//             startIcon={<AddIcon />}
//             onClick={handleCreateDraft}
//             sx={{ borderRadius: 2, backgroundColor: 'warning.main' }}
//           >
//             Create Draft
//           </Button>
//         </Toolbar>
//       </AppBar>

//       {/* Main Content */}
//       <Box sx={{ p: 3 }}>
//         <Paper sx={{ mb: 3, borderRadius: 2, border: 2, borderColor: 'error.light' }}>
//           {/* Search and Filters */}
//           <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
//             <Grid container spacing={2} alignItems="center">
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   placeholder="Search inactive animals by tag, name, exit reason..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   InputProps={{
//                     startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
//                   }}
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
//                   <Button
//                     startIcon={<FilterIcon />}
//                     onClick={() => setShowFilters(!showFilters)}
//                     variant={showFilters ? "contained" : "outlined"}
//                     size="small"
//                     color="error"
//                   >
//                     Filters
//                   </Button>
//                   <Button onClick={resetFilters} variant="outlined" size="small" color="error">
//                     Reset
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>

//             {/* Expandable Filters */}
//             {showFilters && (
//               <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Species</InputLabel>
//                       <Select
//                         value={filters.species}
//                         onChange={(e) => handleFilterChange('species', e.target.value)}
//                         label="Species"
//                       >
//                         <MenuItem value="">All Species</MenuItem>
//                         {options.species?.map(species => (
//                           <MenuItem key={species} value={species}>{species}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Breed</InputLabel>
//                       <Select
//                         value={filters.breed}
//                         onChange={(e) => handleFilterChange('breed', e.target.value)}
//                         label="Breed"
//                       >
//                         <MenuItem value="">All Breeds</MenuItem>
//                         {options.breeds?.[filters.species]?.map(breed => (
//                           <MenuItem key={breed} value={breed}>{breed}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Gender</InputLabel>
//                       <Select
//                         value={filters.sex}
//                         onChange={(e) => handleFilterChange('sex', e.target.value)}
//                         label="Gender"
//                       >
//                         <MenuItem value="">All Genders</MenuItem>
//                         {options.sexes?.map(sex => (
//                           <MenuItem key={sex} value={sex}>{sex}</MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} sm={6} md={3}>
//                     <FormControl fullWidth size="small">
//                       <InputLabel>Type</InputLabel>
//                       <Select
//                         value={filters.animal_type}
//                         onChange={(e) => handleFilterChange('animal_type', e.target.value)}
//                         label="Type"
//                       >
//                         <MenuItem value="">All Types</MenuItem>
//                         <MenuItem value="born">Born</MenuItem>
//                         <MenuItem value="purchased">Purchased</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>
//                 </Grid>
//               </Box>
//             )}
//           </Box>

//           {/* Content Area */}
//           <Box sx={{ p: 2 }}>
            
            
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//                 <CircularProgress color="error" />
//               </Box>
//             ) : filteredAnimals.length === 0 ? (
//               <Card sx={{ textAlign: 'center', p: 4, border: 2, borderColor: 'error.light' }}>
//                 <CardContent>
//                   <InactiveIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
//                   <Typography variant="h5" color="error.main" gutterBottom>
//                     No inactive animals found
//                   </Typography>
//                   <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
//                     Inactive animals will appear here when they are sold, transferred, or removed from the farm
//                   </Typography>
//                   <Button variant="contained" color="error" onClick={handleCreateDraft} size="large">
//                     Create New Animal
//                   </Button>
//                 </CardContent>
//               </Card>
//             ) : (
//               <Paper elevation={0} sx={{ height: 600, border: 1, borderColor: 'error.light', borderRadius: 1 }}>
//                 <TableVirtuoso
//                   data={filteredAnimals}
//                   components={VirtuosoTableComponents}
//                   fixedHeaderContent={fixedHeaderContent}
//                   itemContent={rowContent}
//                 />
//               </Paper>
//             )}
//           </Box>
//         </Paper>
//       </Box>

//       {/* Add FAB for mobile */}
//       <Fab
//         color="error"
//         aria-label="add"
//         sx={{
//           position: 'fixed',
//           bottom: 24,
//           right: 24,
//           display: { xs: 'flex', md: 'none' }
//         }}
//         onClick={handleCreateDraft}
//       >
//         <AddIcon />
//       </Fab>
//     </Box>
//   );
// };

// export default InactiveAnimalsPage;




import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  IconButton,
  Paper,
  Grid,
  Card,
  CardContent,
  Alert,
  CircularProgress,
  AppBar,
  Toolbar,
  Fab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  Close as CloseIcon,
  Pets as PetsIcon,
  FilterList as FilterIcon,
  Search as SearchIcon,
  Pause as InactiveIcon,
  PlayArrow as ReactivateIcon,
} from "@mui/icons-material";
import { TableVirtuoso } from "react-virtuoso";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

// Color constants
const PRIMARY_COLOR = '#024A59';
const SECONDARY_COLOR = '#FFA916';
const PRIMARY_LIGHT = '#346875';
const PRIMARY_DARK = '#013440';

// Virtualized Table Components
const VirtuosoTableComponents = {
  Scroller: React.forwardRef((props, ref) => (
    <TableContainer component={Paper} {...props} ref={ref} />
  )),
  Table: (props) => (
    <Table
      {...props}
      sx={{ borderCollapse: "separate", tableLayout: "fixed" }}
    />
  ),
  TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
  TableRow: (props) => <TableRow {...props} />,
  TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
};

const InactiveAnimalsPage = () => {
  const navigate = useNavigate();
  const [animals, setAnimals] = useState([]);
  const [filteredAnimals, setFilteredAnimals] = useState([]);
  const [loading, setLoading] = useState(false);
  
  // Filters and Search
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [filters, setFilters] = useState({
    species: "",
    breed: "",
    sex: "",
    animal_type: ""
  });

  const [showFilters, setShowFilters] = useState(false);

  // Options and Form Data
  const [options, setOptions] = useState({
    species: [],
    breeds: {},
    sexes: [],
    animal_classes: {},
    lifecycle_states: [],
    reproductive_statuses: [],
    pregnancy_statuses: [],
    milking_statuses: [],
    semen_statuses: [],
    health_statuses: []
  });

  const API_URL = "https://dairy.server.statify.co.ke/api/animals";

  // Table Columns for Virtualized Table
  const columns = [
    { width: 120, label: 'Tag #', dataKey: 'tag_number' },
    { width: 120, label: 'Name', dataKey: 'name' },
    { width: 100, label: 'Species', dataKey: 'species' },
    { width: 120, label: 'Breed', dataKey: 'breed' },
    { width: 100, label: 'Type', dataKey: 'animal_type' },
    { width: 80, label: 'Age', dataKey: 'age_string' },
    { width: 80, label: 'Gender', dataKey: 'sex' },
    { width: 120, label: 'Exit Reason', dataKey: 'exit_reason' },
    { width: 100, label: 'Exit Date', dataKey: 'exit_date' },
    { width: 180, label: 'Actions', dataKey: 'actions' },
  ];

  // Fetch Options
  const fetchOptions = async () => {
    try {
      const res = await fetch(`${API_URL}/options`);
      const data = await res.json();
      if (res.ok) {
        setOptions(data);
      }
    } catch (err) {
      console.error('Error fetching options:', err);
    }
  };

  // Fetch Inactive Animals
  const fetchAnimals = async () => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value) queryParams.append(key, value);
      });
      queryParams.append('lifecycle_state', 'Inactive');

      const url = `${API_URL}?${queryParams.toString()}`;
      const res = await fetch(url);
      const data = await res.json();
      
      if (data.animals && Array.isArray(data.animals)) {
        setAnimals(data.animals);
      } else if (Array.isArray(data)) {
        setAnimals(data);
      } else {
        setAnimals([]);
      }
    } catch (err) {
      console.error('Error fetching inactive animals:', err);
      swal("Error", "Failed to fetch inactive animals", "error");
      setAnimals([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOptions();
    fetchAnimals();
  }, [filters]);

  // Filter animals based on search
  useEffect(() => {
    if (!Array.isArray(animals)) {
      setFilteredAnimals([]);
      return;
    }
    
    let results = animals;

    // Apply search term
    if (searchTerm) {
      results = results.filter(animal =>
        (animal.tag_number?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (animal.name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (animal.breed?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (animal.herd_id?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (animal.exit_reason?.toLowerCase() || '').includes(searchTerm.toLowerCase())
      );
    }

    // Apply sorting
    if (sortConfig.key) {
      results.sort((a, b) => {
        const aVal = a[sortConfig.key];
        const bVal = b[sortConfig.key];
        
        if (aVal === null || aVal === undefined) return 1;
        if (bVal === null || bVal === undefined) return -1;
        
        if (typeof aVal === 'string' && typeof bVal === 'string') {
          return sortConfig.direction === 'asc' 
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
        }
        
        if (aVal < bVal) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aVal > bVal) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    setFilteredAnimals(results);
  }, [animals, searchTerm, sortConfig]);

  // Sort Handler
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Filter Handlers
  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const resetFilters = () => {
    setFilters({
      species: "",
      breed: "",
      sex: "",
      animal_type: ""
    });
    setSearchTerm("");
    setSortConfig({ key: null, direction: 'asc' });
  };

  const handleReactivateAnimal = async (animalId) => {
    const confirm = await swal({
      title: "Reactivate Animal?",
      text: "This will change the animal status back to Active",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirm) {
      try {
        const res = await fetch(`${API_URL}/${animalId}/status`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ 
            lifecycle_state: "Active",
            changed_by: "user" 
          }),
        });

        const data = await res.json();
        if (res.ok) {
          swal("Success", "Animal reactivated successfully!", "success");
          fetchAnimals();
        } else {
          swal("Error", data.error, "error");
        }
      } catch (err) {
        swal("Error", "Something went wrong", "error");
      }
    }
  };

  // Delete Handler
  const handleDelete = async (id) => {
    const confirm = await swal({
      title: "Are you sure?",
      text: "This will permanently delete the animal!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirm) {
      try {
        const res = await fetch(`${API_URL}/${id}`, { method: "DELETE" });
        const data = await res.json();
        if (res.ok) {
          swal("Deleted!", data.message, "success");
          fetchAnimals();
        } else {
          swal("Error", data.error, "error");
        }
      } catch (err) {
        swal("Error", "Something went wrong", "error");
      }
    }
  };

  // View Handler - Navigate to detail page
  const handleView = (animalId) => {
    navigate(`/animals/${animalId}`);
  };

  // Navigate to create draft
  const handleCreateDraft = () => {
    navigate('/animals/draft');
  };

  // Virtualized Table Content
  const fixedHeaderContent = () => (
    <TableRow>
      {columns.map((column) => (
        <TableCell
          key={column.dataKey}
          variant="head"
          align="left"
          style={{ width: column.width }}
          sx={{ 
            backgroundColor: PRIMARY_COLOR, 
            color: 'white',
            fontWeight: 'bold',
            fontSize: '14px',
            padding: '12px 8px'
          }}
        >
          <TableSortLabel
            active={sortConfig.key === column.dataKey}
            direction={sortConfig.direction}
            onClick={() => handleSort(column.dataKey)}
            sx={{ color: 'white !important' }}
          >
            {column.label}
          </TableSortLabel>
        </TableCell>
      ))}
    </TableRow>
  );

  const rowContent = (index, animal) => (
    <React.Fragment>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" fontWeight="bold" noWrap>
          {animal.tag_number}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {animal.name || 'N/A'}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {animal.species}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {animal.breed}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Chip 
          label={animal.purchase_price ? "PURCHASED" : "BORN"} 
          size="small"
          color={animal.purchase_price ? "primary" : "success"}
          sx={{ 
            fontSize: '0.7rem', 
            height: '24px',
            backgroundColor: animal.purchase_price ? PRIMARY_LIGHT : '#4caf50'
          }}
        />
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {animal.age_string || 'N/A'}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {animal.sex}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Chip 
          label={animal.exit_reason || 'Not specified'} 
          size="small"
          sx={{ 
            fontSize: '0.7rem', 
            height: '24px',
            backgroundColor: PRIMARY_COLOR,
            color: 'white'
          }}
        />
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Typography variant="body2" noWrap>
          {animal.exit_date ? new Date(animal.exit_date).toLocaleDateString() : 'N/A'}
        </Typography>
      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'nowrap' }}>
          <IconButton 
            size="small" 
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              color: PRIMARY_COLOR
            }}
            onClick={() => handleView(animal.id)}
          >
            <ViewIcon fontSize="small" />
          </IconButton>
          <Button 
            size="small" 
            variant="contained" 
            startIcon={<ReactivateIcon />}
            onClick={() => handleReactivateAnimal(animal.id)}
            sx={{ 
              minWidth: 'auto',
              px: 1,
              fontSize: '0.7rem',
              height: '32px',
              backgroundColor: SECONDARY_COLOR,
              '&:hover': {
                backgroundColor: '#e59400'
              }
            }}
          >
            Reactivate
          </Button>
          <IconButton 
            size="small" 
            sx={{ 
              minWidth: '32px', 
              width: '32px', 
              height: '32px',
              color: '#d32f2f'
            }}
            onClick={() => handleDelete(animal.id)}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      </TableCell>
    </React.Fragment>
  );

  return (
    <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
      {/* Header */}
      <AppBar position="static" elevation={2} sx={{ backgroundColor: PRIMARY_COLOR }}>
        <Toolbar>
          <InactiveIcon sx={{ mr: 2 }} />
          <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
            Inactive Animals
          </Typography>
          <Chip 
            label={`${animals.length} Inactive`} 
            sx={{ 
              backgroundColor: SECONDARY_COLOR, 
              color: 'white', 
              fontWeight: 'bold', 
              mr: 2 
            }}
          />
          <Button 
            variant="contained" 
            startIcon={<AddIcon />}
            onClick={handleCreateDraft}
            sx={{ 
              borderRadius: 2, 
              backgroundColor: SECONDARY_COLOR,
              '&:hover': {
                backgroundColor: '#e59400'
              }
            }}
          >
           Onboard Animal
          </Button>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box sx={{ p: 3 }}>
        <Paper sx={{ 
          mb: 3, 
          borderRadius: 2, 
          border: 2, 
          borderColor: PRIMARY_LIGHT 
        }}>
          {/* Search and Filters */}
          <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  placeholder="Search inactive animals by tag, name, exit reason..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                  <Button
                    startIcon={<FilterIcon />}
                    onClick={() => setShowFilters(!showFilters)}
                    variant={showFilters ? "contained" : "outlined"}
                    size="small"
                    sx={{
                      backgroundColor: showFilters ? PRIMARY_COLOR : 'transparent',
                      color: showFilters ? 'white' : PRIMARY_COLOR,
                      borderColor: PRIMARY_COLOR,
                      '&:hover': {
                        backgroundColor: showFilters ? PRIMARY_DARK : 'rgba(2, 74, 89, 0.04)',
                        borderColor: PRIMARY_DARK,
                      }
                    }}
                  >
                    Filters
                  </Button>
                  <Button 
                    onClick={resetFilters} 
                    variant="outlined" 
                    size="small" 
                    sx={{
                      color: PRIMARY_COLOR,
                      borderColor: PRIMARY_COLOR,
                      '&:hover': {
                        borderColor: PRIMARY_DARK,
                        backgroundColor: 'rgba(2, 74, 89, 0.04)',
                      }
                    }}
                  >
                    Reset
                  </Button>
                </Box>
              </Grid>
            </Grid>

            {/* Expandable Filters */}
            {showFilters && (
              <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Species</InputLabel>
                      <Select
                        value={filters.species}
                        onChange={(e) => handleFilterChange('species', e.target.value)}
                        label="Species"
                      >
                        <MenuItem value="">All Species</MenuItem>
                        {options.species?.map(species => (
                          <MenuItem key={species} value={species}>{species}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Breed</InputLabel>
                      <Select
                        value={filters.breed}
                        onChange={(e) => handleFilterChange('breed', e.target.value)}
                        label="Breed"
                      >
                        <MenuItem value="">All Breeds</MenuItem>
                        {options.breeds?.[filters.species]?.map(breed => (
                          <MenuItem key={breed} value={breed}>{breed}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Gender</InputLabel>
                      <Select
                        value={filters.sex}
                        onChange={(e) => handleFilterChange('sex', e.target.value)}
                        label="Gender"
                      >
                        <MenuItem value="">All Genders</MenuItem>
                        {options.sexes?.map(sex => (
                          <MenuItem key={sex} value={sex}>{sex}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Type</InputLabel>
                      <Select
                        value={filters.animal_type}
                        onChange={(e) => handleFilterChange('animal_type', e.target.value)}
                        label="Type"
                      >
                        <MenuItem value="">All Types</MenuItem>
                        <MenuItem value="born">Born</MenuItem>
                        <MenuItem value="purchased">Purchased</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>

          {/* Content Area */}
          <Box sx={{ p: 2 }}>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                <CircularProgress sx={{ color: PRIMARY_COLOR }} />
              </Box>
            ) : filteredAnimals.length === 0 ? (
              <Card sx={{ 
                textAlign: 'center', 
                p: 4, 
                border: 2, 
                borderColor: PRIMARY_LIGHT 
              }}>
                <CardContent>
                  <InactiveIcon sx={{ 
                    fontSize: 64, 
                    color: PRIMARY_COLOR, 
                    mb: 2 
                  }} />
                  <Typography variant="h5" sx={{ color: PRIMARY_COLOR }} gutterBottom>
                    No inactive animals found
                  </Typography>
                  <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                    Inactive animals will appear here when they are sold, transferred, or removed from the farm
                  </Typography>
                  <Button 
                    variant="contained" 
                    sx={{ 
                      backgroundColor: SECONDARY_COLOR,
                      '&:hover': {
                        backgroundColor: '#e59400'
                      }
                    }} 
                    onClick={handleCreateDraft} 
                    size="large"
                  >
                    Onboarding New Animal
                  </Button>
                </CardContent>
              </Card>
            ) : (
              <Paper elevation={0} sx={{ 
                height: 600, 
                border: 1, 
                borderColor: PRIMARY_LIGHT, 
                borderRadius: 1 
              }}>
                <TableVirtuoso
                  data={filteredAnimals}
                  components={VirtuosoTableComponents}
                  fixedHeaderContent={fixedHeaderContent}
                  itemContent={rowContent}
                />
              </Paper>
            )}
          </Box>
        </Paper>
      </Box>

      {/* Add FAB for mobile */}
      <Fab
        aria-label="add"
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          display: { xs: 'flex', md: 'none' },
          backgroundColor: PRIMARY_COLOR,
          '&:hover': {
            backgroundColor: PRIMARY_DARK
          }
        }}
        onClick={handleCreateDraft}
      >
        <AddIcon />
      </Fab>
    </Box>
  );
};

export default InactiveAnimalsPage;